// components/Modal.js
import React, { useEffect } from 'react';
import '../styles/Modal.css';

// Props:
//   onClose  – Function           – schließt den Dialog (Pflicht)
//   children – ReactNode          – Inhalt des Dialogs (Pflicht)
//   onPrev   – Function | null    – Callback für "vorheriges Bild" (zeigt Pfeil-Button links)
//   onNext   – Function | null    – Callback für "nächstes Bild" (zeigt Pfeil-Button rechts)
//   counter  – string | null      – optionale Anzeige, z.B. "2 / 5"
//   title    – string | null      – optionaler Titel im Header
function Modal({ onClose, children, onPrev = null, onNext = null, counter = null, title = null }) {
  // Tastatursteuerung: ESC schließt, Pfeiltasten navigieren (wenn onPrev/onNext gesetzt)
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        onClose();
      } else if (event.key === 'ArrowLeft' && onPrev) {
        onPrev();
      } else if (event.key === 'ArrowRight' && onNext) {
        onNext();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [onClose, onPrev, onNext]);

  // Hintergrund-Scroll sperren
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  return (
    <div className="modal-overlay" onClick={onClose} role="dialog" aria-modal="true">
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>

        {/* Header: Titel und/oder Bildnummer – nur rendern wenn vorhanden */}
        {(title || counter) && (
          <div className="modal-header">
            {title && <span className="modal-title">{title}</span>}
            {counter && <span className="modal-counter">{counter}</span>}
          </div>
        )}

        {/* Schließen-Button */}
        <button
          className="modal-close"
          onClick={onClose}
          aria-label="Dialog schließen"
        >
          ×
        </button>

        {/* Navigations-Buttons (nur wenn Callbacks übergeben wurden) */}
        {onPrev && (
          <button
            className="modal-nav modal-prev"
            onClick={onPrev}
            aria-label="Vorheriges Bild"
          >
            &#8249;
          </button>
        )}
        {onNext && (
          <button
            className="modal-nav modal-next"
            onClick={onNext}
            aria-label="Nächstes Bild"
          >
            &#8250;
          </button>
        )}

        {children}
      </div>
    </div>
  );
}

export default Modal;
